import {axiosInstance} from "./AxiosDefaults";
import {Disposition} from "../models/Disposition";

export const sendDispositionEmails = (email: string, allDispositions: Disposition[]): Promise<any> => {
    return axiosInstance.post(
        `/dispositions/send-disposition-emails`,
        {
            email,
            allDispositions,
        },
        {
            withCredentials: false,
            headers: {'Content-Type': 'application/json'}
        }
    );
}